<template>
  <div class="efo-act-popup">
    <DialogPopup
      v-if="!isH5"
      :show="isShow"
      width="470px"
      :append-to-body="true"
      @close="closeDrawer"
    >
      <div class="header-box-coupon">
        <PageMbHeader
          :title="title"
          :iconClass="isH5 ? 'icon-linetype_back_iOS' : 'icon-outline_close'"
          :transShow="false"
          :transOpen="false"
          @icon-click="closeDrawer"
        />
      </div>
      <div class="content_info_box">
        {{content}}
      </div>
    </DialogPopup>
    <DrawerPopup
      direction="btt"
      :bottomShow="false"
      size="80%"
      v-if="isH5"
      :show="isShow"
      :title="title"
      @close="closeDrawer"
      :appendToBody="fasle"
    >
      <div class="content_info_box">
        {{content}}
      </div>
    </DrawerPopup>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DrawerPopup from '@/components/DrawerPopup';
import DialogPopup from '@/components/DialogPopup';
import PageMbHeader from '@/components/PageMbHeader';

export default {
  name: 'efoPopup',
  components: {
    DrawerPopup,
    DialogPopup,
    PageMbHeader,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    content: {
      type: String,
    }
  },
  data() {
    return {
      isShow: false,
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
  },
  watch: {
    value(val) {
      this.isShow = val;
    },
    isShow(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    closeDrawer() {
      this.isShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content_info_box {
  overflow: auto;
  max-height: 630px;
  overflow: auto;
  padding: 75px 24px 24px 24px;
  font-family: 'Aspira Light';
  font-weight: 200;  
  font-size: 14px;
  color: #000000;
  line-height: 18px;
  white-space: pre-line;
}

.info-btn {
  padding: 12px 24px 20px 0;
  display: flex;
  justify-content: flex-end;
}

.header-box-coupon {
  .cate-header-wrapper {
    background: #f5f5f7;
  }
}

@media screen and (max-width: 768px) {
  .content_info_box{
    padding-top: 0;
    max-height: 90%;
  }
}
</style>

<style lang="scss">
.efo-act-popup {
  .el-floating {
    background: #f5f5f7;
  }
  .el-drawer {
    background: #f5f5f7;
  }
}
</style>
